import { createFileRoute } from "@tanstack/react-router"
import { GorgiasIntegration } from "modules/settings/components/integrations/gorgias"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/settings/integrations/gorgias")({
  component: GorgiasIntegration,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("settings.integrations.gorgias.title"),
    })
  },
})
